const MyAccount = () => {
    // Wait for the DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function () {
        const myAccountIcon = document.querySelector('.header__icon--login');
        const myAccount = document.getElementById('myAccount');
        const closeMyAccountBtn = document.getElementById('closeMyAccountBtn');
        const overlay = document.getElementById('overlay');
        const tabs = document.querySelectorAll('.my-account__tab-button');
        
        // Function to open the popup
        function openMyAccount() {
            myAccount.classList.add('active');
            overlay.classList.add('active');
        }

        // Function to close the popup
        function closeMyAccount() {
            myAccount.classList.remove('active');
            overlay.classList.remove('active');
        }

        if(myAccountIcon) {
            // Event listener to open when icon is clicked
            myAccountIcon.addEventListener('click', openMyAccount);
        }

        // Event listener to close when close button is clicked
        closeMyAccountBtn.addEventListener('click', closeMyAccount);

        // Close when pressing the Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && myAccount.classList.contains('active')) {
                closeMyAccount();
            }
        });

        // Switch to the register form
        document.getElementById('switch-to-register').addEventListener('click', function(e) {
            e.preventDefault();
            document.getElementById('login-form').style.display = 'none';
            document.getElementById('register-form').style.display = 'block';
        });

        // Switch to the login form
        document.getElementById('switch-to-login').addEventListener('click', function(e) {
            e.preventDefault();
            document.getElementById('register-form').style.display = 'none';
            document.getElementById('login-form').style.display = 'block';
        });

        // Function to handle tab switching
        function showTab(tabName) {
            // Hide all tab content
            const tabs = document.querySelectorAll('.my-account__tab-content');
            tabs.forEach(function(tab) {
                tab.classList.remove('my-account__tab-content--active');
            });
        
            // Remove active class from all tab buttons
            const tabButtons = document.querySelectorAll('.my-account__tab-button');
            tabButtons.forEach(function(button) {
                button.parentElement.classList.remove('my-account__tab-item--active');
            });
        
            // Show the selected tab content and add active class to the button
            document.getElementById(tabName).classList.add('my-account__tab-content--active');
            document.getElementById(tabName + '-tab').classList.add('my-account__tab-item--active');
        }

        // Add event listeners to tab buttons for switching tabs
        tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                const tabName = this.dataset.tab;
                showTab(tabName);
            });
        });

    });
}

export default MyAccount;
